import { Observable } from 'rxjs';

import { SnCamera, SnLocation, SnFloor, SnTags } from '@lib/api/entities';
import { FsAdvancedMarker } from '@lib/geo/google/map';

import { IFsMap } from '../types';

export abstract class FsMapLocationsServiceProvider<TMap extends IFsMap> {
  public abstract geospatialProvider: string;
  public abstract id: string;

  public abstract get cameraSelected$(): Observable<SnCamera>;
  public abstract get cameraTags$(): Observable<SnTags>;
  public abstract get removePolyline$(): Observable<void>;
  public abstract get hovered$(): Observable<SnCamera | null>;
  public abstract get sdsFloorCameras$(): Observable<SnCamera[]>;
  public abstract get selectedFloor$(): Observable<SnFloor | null>;
  public abstract get selectionChange$(): Observable<SnLocation | null>;

  public abstract getMarkers(): FsAdvancedMarker[];
  public abstract onMapLoaded(map: TMap): void;
  public abstract addToMap(): void;
  public abstract removeFromMap(): void;
  public abstract setFloor(floor: SnFloor): void;
  public abstract showRoomClearedIcons(openRoomClearingMenu: boolean): void;
  public abstract removeAllClearRoomMarkers(): void;
  public abstract getCameras(): SnCamera[];
  public abstract deselectAlarm(): void;
  public abstract setSelectionParams(locationId: string, move: boolean, keepAlarmPopup: boolean): void;
  public abstract clearRoom(release: any): void;
}
